module.exports = __webpack_public_path__ + "img/license-mockup.56a69c1e.svg";